import { urlBase64ToUint8Array } from "../../services/util.service"

const publicVapidKey = process.env.VUE_APP_VAPID_PUB_KEY

export default {
  state: {
    registration: null, // this is the registered service worker
    subscription: null // this is the push notification subscription for the users device
  },
  getters: {
    getSwRegistration(state) {
      return state.registration
    },
    getSwSubscription(state) {
      return state.subscription
    },
    hasNotificationSubscription(state) {
      return !(state.subscription === null)
    },
    isNotificationPermissionDenied(state, getters) {
      return Notification.permission === 'denied' // 'denied', 'default', 'accepted'
    }
  },
  actions: {
    async setSwRegistration({ commit }, registration) {
      commit('SET_SW_REGISTRATION', registration)
    },
    async extractSubscriptionFromRegistration({ commit, getters }) {
      try {
        const registration = getters.getSwRegistration

        const subscription = await registration.pushManager.getSubscription()

        commit('SET_SW_SUBSCRIPTION', subscription)
      } catch (e) {
        console.log('Unable to get Push Subscription', e)
      }
    },
    async promptNotificationPermission({ dispatch, commit, getters }) {
      if (!getters.hasNotificationSubscription
        && !getters.isNotificationPermissionDenied)

        try {
          const registration = getters.getSwRegistration
          const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
          })

          dispatch('recordSubscription', subscription)

          commit('SET_SW_SUBSCRIPTION', subscription)
        } catch (e) {
          console.log('Unable to prompt Notification Permission', e)
        }
    },
    async recordSubscription({}, subscription) {
      this.$api.post('/api/webpush/subscribe', subscription)
        .catch(e => {
          console.log(e)
        })
    }
  },
  mutations: {
    SET_SW_REGISTRATION(state, registration) {
      state.registration = registration || null
    },
    SET_SW_SUBSCRIPTION(state, subscription) {
      state.subscription = subscription || null
    }
  }
}
